<template>
	<modal class="ui--download-confirmation">
		<div class="download-confirmation__inner">
			<ElementText bold content="downloadConfirmationMessage" i18n />
			<ElementText
				bold
				:content="`PackageSize: ${Math.round(getDownloadPackageSize * 0.2 * 100) / 100} MB`"
				i18n
			/>
			<div class="ui--download-confirmation__buttons">
				<ElementButton name="no" @click="hideConfirmationButton($event)" content="no" i18n />
				<ElementButton name="yes" @click="onProceed($event)" content="yes" i18n />
			</div>
		</div>
	</modal>
</template>
<script>
import UiBase from './base.vue';
import { mapState } from 'vuex';
export default {
	extends: UiBase,
	props: {
		tourID: String,
	},
	computed: {
		...mapState(['tour']),
		getDownloadPackageSize() {
			if (Object.prototype.hasOwnProperty.call(this.tour.toursMap, this.tourID)) {
				return this.tour.toursMap[this.tourID].packagesWithVersion.length;
			}
			return null;
		},
	},
	methods: {
		hideConfirmationButton(event) {
			event.stopPropagation();
			event.stopImmediatePropagation();
			this.$emit('hideConfirmationButton');
		},
		onProceed(event) {
			event.stopPropagation();
			event.stopImmediatePropagation();
			this.$emit('onProceed');
		},
	},
};
</script>
